<template>
  <div class="cardCustom">
    <div class="card cardCustom__side">
      <div class="row w-full">
        <div class="col" v-if="$slots.title">
          <slot name="title"></slot>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-lg-12" v-if="$slots.header">
          <slot name="header"></slot>
        </div>
        <div class="col-xs-12 col-lg-12" v-if="$slots.content">
          <slot name="content"></slot>
        </div>
      </div>
      <div v-if="$slots.footer">
        <hr />
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardSummary',
};
</script>

<style scoped></style>
